import { render, staticRenderFns } from "./exam-card.vue?vue&type=template&id=77034c5d&scoped=true&"
import script from "./exam-card.vue?vue&type=script&lang=js&"
export * from "./exam-card.vue?vue&type=script&lang=js&"
import style0 from "./exam-card.vue?vue&type=style&index=0&id=77034c5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77034c5d",
  null
  
)

export default component.exports